import styled from 'helpers/styles';
import {css} from 'styled-components';
import ComponentStyles from 'styles/mixins/Component.styles';
import Tabs from '@mui/material/Tabs';
import constants from 'helpers/constants';
import utils from 'helpers/utils';

const StyledTabs = styled(Tabs)
  .attrs((props) => {
    let attr = props;

    const badgeColorVars = props.theme.color2Css('MuiBadge-badge', null, props.textColor, {
      varPrefix: 'tabs',
      variables: true,
      type: constants.colorTypes.button
    });

    attr = utils.styleProps(attr, badgeColorVars.vars, {badgeColor: badgeColorVars.css});

    const scrollColorVars = props.theme.color2Css('MuiTabScrollButton-root', null, 'default', {
      varPrefix: 'tabs',
      variables: true,
      interactive: true,
      type: constants.colorTypes.outlined
    });

    attr = utils.styleProps(attr, scrollColorVars.vars, {scrollColor: scrollColorVars.css});

    const vars = {
      '--tabs-scroll-button-disabled-color': props.theme.state2Color(props.$color, 'disabled', constants.colorTypes.outlined, constants.colorTargets.foreground),
      '--tabs-scroll-button-disabled-border-color': props.theme.state2Color(props.$color, 'disabled', constants.colorTypes.outlined, constants.colorTargets.background),
      '--tabs-indicator-disabled-background-color': props.theme.property('palette.action.disabled'),
      '--tabs-disabled-color': props.theme.property('palette.action.disabled')
    };

    return utils.styleProps(attr, vars);
  })`
  ${props => props.textColor ? css`
    .MuiBadge-badge {
      ${props => props.$css.badgeColor}
    }
  ` : null}

  .MuiTabScrollButton-root {
    border: 1px solid ${props => props.theme.property('palette.divider')} !important;
    border-radius: ${props => props.theme.radius(1)};
    width: unset;
    height: unset;
    align-self: center;
    opacity: 1;

    ${props => props.$css.scrollColor}
  }

  &.Tabs-size-small {
    .MuiTabScrollButton-root {
      padding: ${props => props.theme.layout(2)};
      svg {
        font-size: ${props => props.theme.fontSize(16)};
      }
    }
  }
  
  &.Tabs-density-dense {
    height: ${props => props.theme.layout(42)};
    min-height: ${props => props.theme.layout(42)};  
    
    .Tab {
      height: ${props => props.theme.layout(42)};
      min-height: ${props => props.theme.layout(42)};
    }
  }

  &.Tabs-disabled {
    .MuiTab-root {
      color: ${props => props.$css.$var('--tabs-disabled-color')};
    }
    .MuiTabs-indicator {
      background-color: ${props => props.$css.$var('--tabs-indicator-disabled-background-color')};
    }
    .MuiTabScrollButton-root {
      pointer-events: none;
      background-color: ${props => props.$css.$var('--tabs-scroll-button-disabled-color')};
      border-color: ${props => props.$css.$var('--tabs-scroll-button-disabled-border-color')};
    }
  }
  
  ${ComponentStyles}
`;

StyledTabs.propTypes = {
};

export default StyledTabs;
